<template>
  <div>
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="period1" v-model="filters.isLeakageTest" />
      <label class="form-check-label" for="period1">Tesnost</label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="period2" v-model="filters.isService" />
      <label class="form-check-label" for="period2">Servis</label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="period3" v-model="filters.isCondenserCleaning" />
      <label class="form-check-label" for="period3">Kondenzator mokro</label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="period6" v-model="filters.isThermometerCal" />
      <label class="form-check-label" for="period6">Termometri</label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="period7" v-model="filters.isCondenserCleaningDry" />
      <label class="form-check-label" for="period7">Kondenzator suho</label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="period8" v-model="filters.isCo2Check" />
      <label class="form-check-label" for="period8">CO2</label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="period9" v-model="filters.isSystemCheck" />
      <label class="form-check-label" for="period9">Sistem</label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="period11" v-model="filters.isAlarmTest" />
      <label class="form-check-label" for="period11">Alarm</label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="period12" v-model="filters.isLedomatCheck" />
      <label class="form-check-label" for="period12">Ledomat</label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="period10" v-model="filters.needsTwo" />
      <label class="form-check-label" for="period10">Dva delavca</label>
    </div>
  </div>
</template>

<script>
// moved out of PeriodicsFilter.js verbatim - options API, there is no setup() to lift
export default {
  name: "PeriodicsFilter",
  props: {
    filters: { type: Object, required: true },
  },
}
</script>
